<template>
  <main class="bg-light-blue w-full text-dark-blue">
    <div class="container">
      <sp2-header class="px-6 lg:px-0"/>
      <section class="flex flex-col md:grid md:grid-cols-4 lg:gap-x-10 lg:grid-cols-5">
        <div class="col-start-1 col-span-4 px-6 lg:px-0">
          <calculate-sp2
            @imputed-paO2="updateImputedPaO2"
            @pf-ratio="updatePfRatio"
            @sf-ratio="updateSfRatio"
          />
        </div>
        <sp2-results :imputedPaO2="imputedPaO2" :pfRatio="pfRatio" :sfRatio="sfRatio" />
      </section>
    </div>
  </main>
</template>

<script setup>
import { ref } from 'vue';

import Sp2Header from '@/modules/Oxygen/components/Sp2topao2/Sp2Header.vue';
import CalculateSp2 from '@/modules/Oxygen/components/Sp2topao2/CalculateSp2.vue';
import Sp2Results from '@/modules/Oxygen/components/Sp2topao2/Sp2Results.vue';

const imputedPaO2 = ref(0);
const pfRatio = ref(0);
const sfRatio = ref(0);

const updateImputedPaO2 = (value) => {
  imputedPaO2.value = value;
};

const updatePfRatio = (value) => {
  pfRatio.value = value;
};

const updateSfRatio = (value) => {
  sfRatio.value = value;
};
</script>
